import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

const Logo = props => {
  return (
      <h1>
        <Link to={'/' + props.language} className="logo-sec main-logo" onClick={props.hideSideMenu}>
        </Link>
      </h1>
  );
};

const mapStateToProps = state => {
  return {
    language: state.layout.iso
  };
};
export default connect(
  mapStateToProps,
  null
)(Logo);
